import React from 'react'
import { SvgIcon } from '../svg-icon'
import styles from './stop-position-icon.module.css'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a position icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <StopPositionIcon width={12} />
 */
const StopPositionIcon = props => (
    <SvgIcon className={styles['stop-position-icon']} viewBox="0 0 48 48" {...props}>
        <path
            d={`M37.659,7.651a19.334,19.334,0,0,0-27.221,0,19.045,19.045,0,0,
            0,.005,27.058C13.928,38.173,24.05,46.05,24.05,46.05s10.126-7.88,
            13.611-11.342a19.047,19.047,0,0,0,0-27.057Zm-.905,26.2c-3.253,
            3.232-12.7,10.586-12.7,10.586S14.6,37.081,11.351,33.85A17.775,
            17.775,0,0,1,11.346,8.6a18.045,18.045,0,0,1,25.406,0,17.776,
            17.776,0,0,1,0,25.253Z`}
        />
        <path
            d={`M36.752,8.593a18.045,18.045,0,0,0-25.406,0,17.775,17.775,0,
            0,0,.005,25.255c3.251,3.23,12.7,10.582,12.7,10.582s9.451-7.354,
            12.7-10.586a17.776,17.776,0,0,0,0-25.253Z`}
        />
        <path d="M18.05,14.05h12v12h-12Z" />
    </SvgIcon>
)

StopPositionIcon.defaultProps = defaultProps

export { StopPositionIcon }
